import { render, staticRenderFns } from "./px-empty-message.vue?vue&type=template&id=f0113bde&scoped=true&"
import script from "./px-empty-message.vue?vue&type=script&lang=ts&"
export * from "./px-empty-message.vue?vue&type=script&lang=ts&"
import style0 from "./px-empty-message.vue?vue&type=style&index=0&id=f0113bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0113bde",
  null
  
)

export default component.exports